/**
 * Build an absolute WebSocket URL on the current origin.
 * http://localhost:5173 → ws://localhost:5173/ws/... (Vite proxies to Django)
 * https://coalcitylife.com → wss://coalcitylife.com/ws/... (Nginx proxies to Uvicorn)
 */
export function wsUrl(path: string): string {
  const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${window.location.host}${path}`;
}